import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: 'img:not([loading]), iframe:not([loading])',
  standalone: true
})
export class LazyLoadMediaDirective {
  constructor(private elementRef: ElementRef<HTMLImageElement | HTMLIFrameElement>) {
    this.elementRef.nativeElement.setAttribute('loading', 'lazy');
  }
}
